import { forwardRef } from 'react';

interface VersionTagProps {
  version: string;
  variantClassName: string;
  emoji: string | null;
  title: string;
  packageName: string;
}

const VersionTag = forwardRef<HTMLSpanElement, VersionTagProps>(
  ({ version, variantClassName, emoji, title, packageName }, ref) => (
    <span ref={ref} title={title} className={`eduzz-ui-version-tag ${variantClassName}`}>
      {emoji && <span className='eduzz-ui-version-tag__emoji'>{emoji}</span>}
      <span className='eduzz-ui-version-tag__label'>{packageName} v{version}</span>
    </span>
  )
);

export default VersionTag;
